import { deleteEquipmentUnitCategory } from "../../../../api";
import { useQuery } from "react-query";
import { Modal, Button } from "react-bootstrap";
import ClipLoader from "react-spinners/ClipLoader";
import { useEffect } from "react";
import { checkForAPISuccess, showSuccessToast, showInfoToast } from "../../../../Common/commonFunctions";
import { RESPONSE_IN_USE_CATEGORY_CODE } from "../../../../Common/constants";
import { useDispatch } from "react-redux";
import _ from "lodash";
import { DELETE_CATEGORY } from "../../../../store/actions";

const DeleteCategoryPopup = props => {

    const dispatch = useDispatch();
    const useQueryConfiguration = {
        enabled: false, retry: false, retryOnMount: false,
        refetchOnMount: false, refetchOnWindowFocus: false
    }

    const deleteCategory = async () => {
        const response = await deleteEquipmentUnitCategory(props.id);
        return response?.data;
    }

    const deleteCategoryQuery = useQuery('delete-category', deleteCategory, { ...useQueryConfiguration });

    useEffect(() => {
        if(deleteCategoryQuery.isFetched) {
            if(checkForAPISuccess(deleteCategoryQuery?.data?.statusCode)) {
                showSuccessToast(`Category ${props.name} deleted successfully`, 3000);
                dispatch({ type: DELETE_CATEGORY, payload: props.id });
            }
            else if(_.isEqual(deleteCategoryQuery?.data?.statusCode, RESPONSE_IN_USE_CATEGORY_CODE)) {
                showInfoToast(`The Category you are trying to delete is applied in some equipment units. Please remove it from there before deleting`, 9000);
                props.closePopup();
            }
            deleteCategoryQuery.remove();
        }
    }, [deleteCategoryQuery.isFetched]);

    return(
        <Modal show onHide={() => props.closePopup()}>
            <Modal.Header closeButton>
                <b>Delete {props.name}</b>
            </Modal.Header>
            <Modal.Body>
                <center className='my-4'>
                    {
                        deleteCategoryQuery.isFetching ?
                            <ClipLoader color='#075978' />
                                :
                            <b>Are you sure to delete {props.name} ?</b>
                    }
                </center>
            </Modal.Body>
            <Modal.Footer>
                <Button disabled={deleteCategoryQuery.isFetching} onClick={() => props.closePopup()} className="secondary-button">No</Button>
                <Button disabled={deleteCategoryQuery.isFetching} onClick={() => deleteCategoryQuery.refetch()}>Yes</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default DeleteCategoryPopup;